export default "__VITE_ASSET__ef723cff__"